export default function Timetable() {
  return (
    <div className="timetable">
      <h2>TIME TABLE</h2>

      <div className="time-item">
        <div className="time-content">
          <span className="project">원데이프로젝트</span>
          <span className="members">
            <strong className="leader">김근주</strong>,{" "}
            <strong className="leader">김진아</strong>, 계하은, 김규은, 김남현
          </span>
          <span className="song">WICKED + FAMOUS</span>
        </div>
      </div>

      <div className="time-item">
        <div className="time-content">
          <span className="members">
            <strong className="leader">서주연</strong>{" "}
          </span>
          <span className="song">focus + style</span>
        </div>
      </div>

      <div className="time-item">
        <div className="time-content">
          <span className="project">하리보</span>
          <span className="members">
            <strong className="leader">계하은</strong>,{" "}
            <strong className="leader">김규은</strong>, 임수연, 송채은
          </span>
          <span className="song">jellyous</span>
        </div>
      </div>

      <div className="time-item">
        <div className="time-content">
          <span className="project">언니가 잘할게</span>
          <span className="members">
            <strong className="leader">보라</strong>,{" "}
            <strong className="leader">임다은</strong>, 서주연, 김진아, 정수민
          </span>
          <span className="song">Abracadabra + Rumor</span>
        </div>
      </div>

      <div className="time-item">
        <div className="time-content">
          <span className="project">중증홍대외상센터</span>
          <span className="members">
            <strong className="leader">김근주</strong>,{" "}
            <strong className="leader">오정현</strong>, 유민제, 김태리, 김남현
          </span>
          <span className="song">FaSHioN</span>
        </div>
      </div>

      <div className="time-item">
        <div className="time-content">
          <span className="project">bad valentine</span>
          <span className="members">
            <strong className="leader">최보미</strong>,{" "}
            <strong className="leader">임수연</strong>, 육민하, 김진아, 계하은, 전수빈
          </span>
          <span className="song">한(一) + blue valntine + 불꽃놀이</span>
        </div>
      </div>

      <div className="time-item">
        <div className="time-content">
          <span className="project">럭키가이</span>
          <span className="members">
            <strong className="leader">김수아</strong>, 송채은, 김규은, 김태리
          </span>
          <span className="song">Lucky</span>
        </div>
      </div>

      <div className="time-item">
        <div className="time-content">
          <span className="project">의심없이 노답</span>
          <span className="members">
            <strong className="leader">김진아</strong>,{" "}
            <strong className="leader">유민제</strong>, 보라, 오정현, 홍수연
          </span>
          <span className="song">No Doubt</span>
        </div>
      </div>

      <div className="time-item">
        <div className="time-content">
          <span className="project">셋떨기</span>
          <span className="members">
            <strong className="leader">최보미</strong>, 임수연, 육민하
          </span>
          <span className="song">Pocket Locket + 스물셋</span>
        </div>
      </div>

      <div className="time-item">
        <div className="time-content">
          <span className="project">빵빵아 댕댕아</span>
          <span className="members">
            <strong className="leader">김수아</strong>, 조윤재, 임다은
          </span>
          <span className="song">10 minutes + Lip&Hip</span>
        </div>
      </div>

      <div className="time-item">
        <div className="time-content">
          <span className="project">사이:콜</span>
          <span className="members">
            <strong className="leader">보라</strong>,{" "}
            <strong className="leader">서주연</strong>, 육민하, 심효진, 배한별
          </span>
          <span className="song">Psycho</span>
        </div>
      </div>

      <div className="time-item">
        <div className="time-content">
          <span className="project">블루밍컴퍼니</span>
          <span className="members">
            <strong className="leader">최보미</strong>,{" "}
            <strong className="leader">유민제</strong>, 임다은, 김근주, 송채은, 홍수연
          </span>
          <span className="song">Hollywood Action</span>
        </div>
      </div>

      <div className="time-item">
        <div className="time-content">
          <span className="project">독한X</span>
          <span className="members">
            <strong className="leader">김수아</strong>, 조윤재, 전수빈
          </span>
          <span className="song">Toxic</span>
        </div>
      </div>

      <div className="time-item">
        <div className="time-content">
          <span className="project">시나브로</span>
          <span className="members">
            <strong className="leader">임수연</strong>, 최보미, 육민하, 정수민, 문여원, 심효진
          </span>
          <span className="song">Toxic</span>
        </div>
      </div>

      <div className="time-item">
        <div className="time-content">
          <span className="project">입김이 나</span>
          <span className="members">
            <strong className="leader">조윤재</strong>, 송채은, 서주연, 배한별
          </span>
          <span className="song">Savage</span>
        </div>
      </div>

    </div>
  );
}
